<template>
  <ConfiguracionComponent />
</template>

<script>
import ConfiguracionComponent from '@/components/Configuracion/ConfiguracionComponent.vue'
export default {
  name: 'ConfiguracionView',
  components: { ConfiguracionComponent }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/ConfiguracionView.vue